import { authApi } from "shared/api/authApi";

export const updateVerifyCodeRequest = (payload) => {
  return authApi.updateVerifyCode(payload);
};
